module.exports = __webpack_public_path__ + "static/media/cart-logo.8421e71f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cart-logo.svg
// module id = 632
// module chunks = 0